import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import axios from 'axios';
import UnifyButton from '../../../../components/Button';
import config from '../../../../config';

const DeleteAdmin = ({
  show, handleClose, setAlert, admin, refetch,
}) => {
  const submit = async () => {
    const resp = await axios.delete(`${config.API_BASE_URL}api/account/delete-admin/${admin.npmnip}`, {
      headers: {
        'content-type': 'application/json',
        accept: 'application/json',
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    });
    if (resp?.data?.Status === 'Success') {
      handleClose();
      setAlert({ type: 'success', message: `Anda berhasil menghapus admin ${admin.name}` });
    } else {
      handleClose();
      setAlert({ type: 'failed', message: 'Terjadi kesalahan saat menghapus admin' });
    }
    refetch();
  };

  return (
    <Modal centered show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Hapus Admin</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {`Apakah Anda yakin ingin menghapus ${admin.name} dari admin?`}
      </Modal.Body>
      <Modal.Footer>
        <UnifyButton color="#CED4DA" onClick={handleClose}>
          Batal
        </UnifyButton>
        <UnifyButton color="#538AC5" onClick={submit}>
          Ya
        </UnifyButton>
      </Modal.Footer>
    </Modal>
  );
};

DeleteAdmin.propTypes = {
  admin: PropTypes.shape({
    name: '', id: 0, npmnip: '', username: '',
  }).isRequired,
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  setAlert: PropTypes.func.isRequired,
  refetch: PropTypes.func.isRequired,
};

export default DeleteAdmin;
